import type { Platform } from '@/contexts/ProtocolContext/ProtocolContext'
import { getMastodonAccountId, type MastodonSession } from '@/lib/mastodon'
import type { PixelfedSession } from '@/lib/pixelfed'
import type { NostrSession } from '@/types/nostr'

export interface AccountQuerySessions {
    session: { did: string } | null | undefined
    mastodonSession: MastodonSession | null | undefined
    pixelfedSession: PixelfedSession | null | undefined
    nostrSession: NostrSession | null | undefined
}

/** Per-account element of every account-scoped react-query key. Mastodon uses the account id
 *  (`mastodon:<host>:<username>`), not the instance URL, so two accounts on one instance never
 *  share an entry (#2458). */
export function accountQueryIdentifier(platform: Platform, s: AccountQuerySessions): string | null {
    switch (platform) {
        case 'bluesky':
            return s.session?.did ?? null
        case 'mastodon':
            return s.mastodonSession ? getMastodonAccountId(s.mastodonSession) : null
        case 'pixelfed':
            return s.pixelfedSession?.instance_url ?? null
        case 'nostr':
            return s.nostrSession?.pubkey ?? null
    }
}
